import { fakePwa } from "config/base"

type WindowExtended = Window &
  typeof globalThis & {
    navigator: { standalone: boolean }
  }

export const isPWA = () => {
  if (fakePwa) return true
  if (typeof window === "undefined" || typeof document === "undefined") return false // @todo test on pwa
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (window as WindowExtended).navigator.standalone ||
    document.referrer.includes("android-app://")
  )
}
